import { finishMaterial } from "./materials";

/**
 * 3D handle for a door or drawer front.
 * w/h = front size; z = front face depth; side = "L" | "R" hinge side for doors; drawer = horizontal placement.
 * upper = overhead cabinet (handles sit near the bottom edge instead of the top).
 */
export const Handle3D = ({ kind, finish, w, h, z, drawer, side = "L", upper }) => {
  const mat = finishMaterial(finish);
  const edgeX = side === "L" ? w / 2 - 0.06 : -w / 2 + 0.06; // opening edge is opposite the hinge
  const topY = upper ? -h / 2 + 0.08 : h / 2 - 0.08;

  if (kind === "profile") {
    const y = upper ? -h / 2 + 0.008 : h / 2 - 0.008;
    return (
      <mesh position={[0, y, z + 0.006]} castShadow>
        <boxGeometry args={[w, 0.016, 0.014]} />
        <meshStandardMaterial {...mat} />
      </mesh>
    );
  }
  if (kind === "knob") {
    const pos = drawer ? [0, 0, z + 0.022] : [edgeX, topY, z + 0.022];
    return (
      <group position={pos}>
        <mesh position={[0, 0, -0.012]}><cylinderGeometry args={[0.006, 0.006, 0.02, 16]} /><meshStandardMaterial {...mat} /></mesh>
        <mesh castShadow><sphereGeometry args={[0.016, 24, 24]} /><meshStandardMaterial {...mat} /></mesh>
      </group>
    );
  }
  if (kind === "cup") {
    const pos = drawer ? [0, 0, z + 0.018] : [edgeX, topY, z + 0.018];
    return (
      <mesh position={pos} rotation={[0, 0, Math.PI / 2]} castShadow>
        <cylinderGeometry args={[0.03, 0.03, 0.1, 24, 1, false, 0, Math.PI]} />
        <meshStandardMaterial {...mat} side={2} />
      </mesh>
    );
  }
  // bar handle: horizontal centred on drawers, vertical at the opening edge on doors
  const len = drawer ? Math.min(0.32, w * 0.45) : Math.min(0.24, h * 0.3);
  const pos = drawer ? [0, 0, z + 0.03] : [edgeX, upper ? topY + len / 2 : topY - len / 2, z + 0.03];
  const rot = drawer ? [0, 0, Math.PI / 2] : [0, 0, 0];
  const posts = [-len / 2 + 0.02, len / 2 - 0.02];
  return (
    <group position={pos} rotation={rot}>
      <mesh castShadow><cylinderGeometry args={[0.0055, 0.0055, len, 20]} /><meshStandardMaterial {...mat} /></mesh>
      {posts.map((p) => (
        <mesh key={p} position={[0, p, -0.016]} rotation={[Math.PI / 2, 0, 0]}><cylinderGeometry args={[0.005, 0.005, 0.03, 12]} /><meshStandardMaterial {...mat} /></mesh>
      ))}
    </group>
  );
};
